import React, { FC, useMemo } from "react";

type DurationProps = {
	duration: number;
};

export const Duration: FC<DurationProps> = ({ duration }) => {
	const durationString = useMemo(() => {
		const minutes = Math.floor(duration / 60);
		const seconds = duration % 60;
		const sMinutes = minutes === 0 ? "" : `${minutes}m `;
		return `(${sMinutes}${seconds}s)`;
	}, [duration]);

	return <span>{durationString}</span>;
};
